/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});var d=(e=>(e.remove="remove",e.add="add",e.reorder="reorder",e))(d||{});const t=(e,r)=>{switch(r.type){case"add":break;case"remove":return e.filter(a=>a[r.valueField]!==r.payload);case"reorder":break;default:return e}};exports.CHIP_DATA_ACTION=d;exports.dataReducer=t;
